module.exports = __webpack_public_path__ + "media/bootstrap-icons/aspect-ratio-fill-4cc7529e.svg";